import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSvgComponent } from './simple-icons-svg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSvgComponent ],
    exports:      [ SimpleIconsSvgComponent ],
    bootstrap:    []
})
export class SimpleIconsSvgModule {}
